import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { pluralizeObject }  from '../../helpers/show_page_helpers';
import pluralize            from 'pluralize';

export default class InviteUsersStage3 extends Component {
  state = {
    emailsSelected: false,
    isSubmittingInvites: false,
    resourcesSelected: false,
    submitButtonEnabled: false,
    textareaValue: ''
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const emailsSelected = nextProps.emailsArray.length ? true : false;
    const resourcesSelected = Object.keys(nextProps.selectedResources).length ? true : false;
    const submitButtonEnabled = emailsSelected && resourcesSelected ? true : false;

    return {emailsSelected, resourcesSelected, submitButtonEnabled}
  }

  handleSubmitInvites() {
    const successOptions = {
      type: 'success',
      title: t('Requests Submitted'),
      text: t('Your invites are processing! Permissions will be updated shortly.'),
      customClass: 'submitting-invites',
      showConfirmButton: true,
      allowOutsideClick: true
    }

    const errorOptions = {
      type: 'error',
      title: t('Submission Failed'),
      text: t('An error occured whill submitting invites. Please try again or contact support.'),
      customClass: 'submitting-invites',
      showConfirmButton: true,
      allowOutsideClick: true
    }


    this.setState({isSubmittingInvites: true, submitButtonEnabled: false}, () => {
      this.submitInvites()
        .then(response => {
          setTimeout(() => {
            this.props.updateInviteState({submitted: true});
            this.setState({isSubmittingInvites: false});
            ReactRailsUJS.unmountComponents('#dialogBody');
            BF.dialog.dismiss();
            swal(successOptions, isConfirm => {
            });
          }, 1500)
        })
        .catch(error => {
          BF.dialog.dismiss();
          swal(errorOptions);
        })
    });
  }

  submitInvites() {
    return fetch('/api/v4/invitations', {
      method: 'POST',
      headers: { 'Authorization' : `Bearer ${BF_Token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(this.buildSubmitData())
    })
  }

  buildSubmitData () {
    const {emailsArray, selectedPermissionLevel, selectedResources} = this.props;
    const {textareaValue} = this.state;

    const emailsArrayText = emailsArray.map(email => email.text);
    const resourcesArray = Object.keys(selectedResources).map(resourceKey => {
      return {
        resource_type: selectedResources[resourceKey].type,
        resource_key: resourceKey
      }
    })

    return {
      data: {
        attributes: {
          emails: emailsArrayText,
          permission_level: selectedPermissionLevel,
          personal_message: textareaValue,
          send_email: true
        },
        resources: resourcesArray
      }
    }

  }

  getEmailList() {
    if (!this.state.emailsSelected) {
      return (
        <React.Fragment>
          <h4 className='missing-input-warning-bold'>{t(`You haven’t entered any email addresses. `)}</h4>
          <h4 className='missing-input-warning'>{t(`Return to step 01 to invite users by email.`)}</h4>
        </React.Fragment>
      )
    }

    return this.props.emailsArray.map((email, i) => {
      return <h4 className='email-copy' key={i}>{email.text}</h4>
    })
  }

  getResourceList() {
    const { libraryName, resources, selectedResources } = this.props;
    const resourcesToSubmit = [];

    if (!this.state.resourcesSelected) {
      return (
        <React.Fragment>
          <h4 className='missing-input-warning-bold'>{t(`You haven't selected any ${pluralize(libraryName)} or Collections.`)}</h4>
          <h4 className='missing-input-warning'>{t(`Return to step 02 to select ${pluralize(libraryName)} and Collections.`)}</h4>
        </React.Fragment>
      )
    }

    Object.keys(resources).forEach(brandfolderKey => {
      if (selectedResources[brandfolderKey]) {
        resourcesToSubmit.push(
          <div className='brandfolder-submit-container submit-container' key={brandfolderKey}>
            <div className='brandfolder-submit-row submit-row'>
              <h4>{selectedResources[brandfolderKey].name}</h4>
            </div>
          </div>
        )
      } else {
        let parentKeyIndicator = false;

        Object.keys(selectedResources).forEach(resourceKey => {
          selectedResources[resourceKey].parent_key === brandfolderKey ? parentKeyIndicator = true : null;
        })

        if (parentKeyIndicator) {
          resourcesToSubmit.push(
            <div className='brandfolder-submit-container submit-container' key={brandfolderKey}>
              <div className='brandfolder-submit-row submit-row not-submitted'>
                <h4>{resources[brandfolderKey].name}</h4>
              </div>
              <div className='collection-submit-container submit-container'>
                {this.buildCollectionsToSubmit(brandfolderKey)}
              </div>
            </div>
          )
        }
      }
    })

    if (resourcesToSubmit.length) {
      resourcesToSubmit.splice(0, 0, <h6 className='resource-title' key={0}>{pluralize(libraryName).toUpperCase()}</h6>);
    }

    return resourcesToSubmit;
  }

  buildCollectionsToSubmit(brandfolderKey) {
    const {selectedResources} = this.props;
    const collectionsToSubmit = [];

    Object.keys(selectedResources).forEach(resourceKey => {
      const selectedResource = selectedResources[resourceKey];

      if (selectedResource.parent_key === brandfolderKey) {
        collectionsToSubmit.push(
          <div className='collection-submit-row submit-row' key={resourceKey}><h4>{selectedResource.name}</h4></div>
        )
      }
    })

    if (collectionsToSubmit.length) {
      collectionsToSubmit.splice(0, 0, <h6 className='resource-title' key={0}>{t('COLLECTIONS')}</h6>);
    }

    return collectionsToSubmit
  }

  submitFeedback() {
    const {emailsArray, selectedResources, submitted} = this.props;
    const {submitButtonEnabled, isSubmittingInvites} = this.state;

    if (!submitButtonEnabled && isSubmittingInvites) {
      return (<h3 className='section-title center'>Submitting...</h3>)
    } else if (submitted) {
      return (<h3 className='section-title center'>{t('Submitted!')}</h3>)
    } else if (!submitButtonEnabled) {
      return (<h3 className='section-title'>{t('Review your selections:')}</h3>)
    }

    const emailQtyObject = pluralizeObject(emailsArray);
    let   brandfoldersToSubmit = 0;
    let   collectionsToSubmit = 0;

    Object.keys(selectedResources).forEach(key => {
      if (selectedResources[key].type === 'brandfolder') {
        brandfoldersToSubmit += 1;
      } else {
        collectionsToSubmit += 1;
      }
    })

    const collectionCopy = collectionsToSubmit > 1 ? 'Collections' : 'Collection';

    return (
      <h3 className='section-title'>
        {t('Are you sure you want to invite')}
        <span className='bold-text'>{emailQtyObject.qty} {t(`user${emailQtyObject.plural}`)}</span>
        <span className='following-copy'>{t('to the following')}</span>
        {brandfoldersToSubmit ? <span>{brandfoldersToSubmit > 1 ? 'Brandfolders' : 'Brandfolder'}</span> : null}
        {brandfoldersToSubmit && collectionsToSubmit? <span className='resource-seperator'>{t('and')}</span> : null}
        {collectionsToSubmit ? <span>{t(collectionCopy)}</span> : null}:
      </h3>
    )
  }

  render () {
    if (this.props.stage !== 3) { return null }

    const { submitted, updateInviteState } = this.props;
    const { submitButtonEnabled, textareaValue } = this.state;

    return (
      <React.Fragment>
        <div className='section-title-container'>
          {this.submitFeedback()}
        </div>
        {this.state.isSubmittingInvites
          ? <video className='brandfolder-loader' width='90' height='90' poster='https://cdn.brandfolder.io/4OQZ5PW1/as/pxmju5-qfr48-21nt37/generic-loader.gif'>Browser Doesn't Support HTML5 Video Tag</video>
          : <div className='section-body body-review-invite'>
          <div className='review-list-container'>
            <div className='email-list'>{this.getEmailList()}</div>
            <div className='resource-list'>{this.getResourceList()}</div>
          </div>
          <div className='personal-message-container'>
            <h3 className='section-title personal-message-copy'>{t('Add a personal message to invited users')}
              <span className='optional-text'>{`(${t('optional')})`}</span>
            </h3>
            <textarea className='textareas'
                      value={textareaValue}
                      onChange={(e) => this.setState({textareaValue: e.target.value})}>
            </textarea>
          </div>
        </div>}
        <div className='button-container'>
          <button className='button tertiary sm'
            onClick={() => updateInviteState({stage: 2})}>
            {t('Back')}
          </button>
          <button className='button primary lg'
                  onClick={() => this.handleSubmitInvites()}
                  disabled={!submitButtonEnabled || submitted}>
            {t('Send Invites')}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

InviteUsersStage3.defaultProps = {
  libraryName: "Brandfolder"
};

InviteUsersStage3.propTypes = {
  emailsArray: PropTypes.array.isRequired,
  libraryName: PropTypes.string,
  resources: PropTypes.object.isRequired,
  selectedPermissionLevel: PropTypes.string.isRequired,
  selectedResources: PropTypes.object.isRequired,
  stage: PropTypes.number.isRequired,
  submitted: PropTypes.bool.isRequired,
  updateInviteState: PropTypes.func.isRequired
};
